(() => {
  const SELECTORS = {
    section: '[data-fc-highlight-text]',
    heading: '[data-fc-highlight-heading]',
    body: '[data-fc-highlight-body]'
  };

  const CLASSES = {
    headingHighlight: 'fc-highlight-text__heading-highlight',
    bodyHighlight: 'fc-highlight-text__body-highlight'
  };

  class FCHighlightText {
    constructor(section) {
      this.section = section;
      this.heading = section.querySelector(SELECTORS.heading);
      this.body = section.querySelector(SELECTORS.body);
      this.init();
    }

    init() {
      if (this.section.dataset.fcHighlightTextInitialized === 'true') return;

      if (this.heading) {
        this.processContainer(this.heading, CLASSES.headingHighlight);
      }

      if (this.body) {
        this.processContainer(this.body, CLASSES.bodyHighlight);
      }

      this.section.dataset.fcHighlightTextInitialized = 'true';
    }

    processContainer(container, highlightClass) {
      if (!container || container.dataset.fcHighlightProcessed === 'true') return;

      const textNodes = this.getTextNodes(container, highlightClass);
      let highlightActive = false;

      textNodes.forEach((textNode) => {
        const result = this.processTextNode(
          textNode,
          highlightClass,
          highlightActive
        );

        highlightActive = result.highlightActive;
      });

      container.dataset.fcHighlightProcessed = 'true';
    }

    getTextNodes(container, highlightClass) {
      const textNodes = [];
      const walker = document.createTreeWalker(
        container,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: (node) => {
            const parent = node.parentElement;

            if (!parent) return NodeFilter.FILTER_REJECT;

            if (
              parent.closest('script, style, template') ||
              parent.closest(`.${highlightClass}`)
            ) {
              return NodeFilter.FILTER_REJECT;
            }

            if (!node.nodeValue || node.nodeValue.length === 0) {
              return NodeFilter.FILTER_REJECT;
            }

            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      let currentNode = walker.nextNode();

      while (currentNode) {
        textNodes.push(currentNode);
        currentNode = walker.nextNode();
      }

      return textNodes;
    }

    processTextNode(textNode, highlightClass, initialHighlightState) {
      const sourceText = textNode.nodeValue;
      const fragment = document.createDocumentFragment();

      let highlightActive = initialHighlightState;
      let index = 0;
      let buffer = '';
      let hasMarker = false;

      const appendBuffer = () => {
        if (!buffer) return;

        if (highlightActive) {
          const highlightElement = document.createElement('span');
          highlightElement.className = highlightClass;
          highlightElement.textContent = buffer;
          fragment.appendChild(highlightElement);
        } else {
          fragment.appendChild(document.createTextNode(buffer));
        }

        buffer = '';
      };

      while (index < sourceText.length) {
        const characterPair = sourceText.slice(index, index + 2);

        if (characterPair === '[[' && !highlightActive) {
          const closingIndex = sourceText.indexOf(']]', index + 2);

          if (closingIndex !== -1) {
            appendBuffer();
            highlightActive = true;
            hasMarker = true;
            index += 2;
            continue;
          }
        }

        if (characterPair === ']]' && highlightActive) {
          appendBuffer();
          highlightActive = false;
          hasMarker = true;
          index += 2;
          continue;
        }

        buffer += sourceText[index];
        index += 1;
      }

      appendBuffer();

      const containsHighlight =
        fragment.querySelector(`.${highlightClass}`) !== null;

      if (hasMarker || initialHighlightState || containsHighlight) {
        textNode.replaceWith(fragment);
      }

      return { highlightActive };
    }
  }

  const initializeSections = (root = document) => {
    const sections = [];

    if (root.matches && root.matches(SELECTORS.section)) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(SELECTORS.section).forEach((section) => {
        sections.push(section);
      });
    }

    sections.forEach((section) => {
      if (section.dataset.fcHighlightTextInitialized === 'true') return;
      new FCHighlightText(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeSections(),
      { once: true }
    );
  } else {
    initializeSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeSections(event.target);
  });
})();